import { render, staticRenderFns } from "./sharia.vue?vue&type=template&id=044d0928"
import script from "./sharia.vue?vue&type=script&lang=js"
export * from "./sharia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports